import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PasswordVisibilityField } from "@/components/PasswordVisibilityField";

export const TemporaryPasswordModal = () => {
  const { logout, refreshUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (saving) return;
    if (next !== confirm) { setError("Le due nuove password non coincidono."); return; }
    setError(""); setSaving(true);
    try {
      await api.post("/me/change-password", { current_password: current, new_password: next });
      await refreshUser();
      toast.success("Password personale salvata");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Impossibile cambiare la password. Riprova.");
    } finally { setSaving(false); }
  };

  return <Dialog open onOpenChange={() => {}} modal>
    <DialogContent showCloseButton={false} onEscapeKeyDown={(e) => e.preventDefault()}
      onPointerDownOutside={(e) => e.preventDefault()}
      className="left-0 top-0 translate-x-0 translate-y-0 w-screen max-w-none h-[100dvh] sm:rounded-none bg-[#FAF9F6] border-0 shadow-none p-0 flex flex-col gap-0"
      data-testid="temporary-password-modal">
      <DialogHeader className="shrink-0 border-b border-[#E5E5E0] bg-white px-5 sm:px-10 py-5 flex-row items-center justify-between gap-3 text-left">
        <div className="min-w-0">
          <span className="inline-flex items-center gap-2 text-xs uppercase text-[#4A6B53]">
            <KeyRound className="h-4 w-4" /> Cosmely · Protezione account
          </span>
          <DialogTitle className="font-serif text-2xl sm:text-3xl mt-2">Crea la tua password</DialogTitle>
          <DialogDescription className="text-sm text-[#707070] mt-1">
            La password che hai ricevuto è temporanea. Scegline una personale per continuare.
          </DialogDescription>
        </div>
        <Button type="button" variant="outline" onClick={logout} data-testid="temporary-password-logout">Esci</Button>
      </DialogHeader>
      <div className="flex-1 flex items-center justify-center overflow-y-auto px-5 py-10">
        <form onSubmit={submit} className="w-full max-w-md border-t-2 border-[#C5B39B] bg-white p-6 sm:p-9 shadow-sm space-y-5"
          data-testid="temporary-password-form">
          <p className="font-serif text-2xl">Scegli una nuova password</p>
          <div><label htmlFor="temporary-current" className="label-tiny">Password temporanea</label>
            <PasswordVisibilityField id="temporary-current" testId="temporary-password-current"
              value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" required /></div>
          <div><label htmlFor="temporary-new" className="label-tiny">Nuova password</label>
            <PasswordVisibilityField id="temporary-new" testId="temporary-password-new"
              value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" minLength={6} required /></div>
          <div><label htmlFor="temporary-confirm" className="label-tiny">Conferma nuova password</label>
            <PasswordVisibilityField id="temporary-confirm" testId="temporary-password-confirm"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" minLength={6} required /></div>
          {error && <p role="alert" className="text-sm text-[#8C3A3A]" data-testid="temporary-password-error">{error}</p>}
          <Button type="submit" disabled={saving} className="w-full bg-[#1A1A1A] text-white hover:bg-black"
            data-testid="temporary-password-submit">
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Salva e continua
          </Button>
        </form>
      </div>
    </DialogContent>
  </Dialog>;
};